/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeleteFileInput = {
    files?: Array<string | null> | null | undefined;
    taskId?: string | null | undefined;
    projectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deleteFileMutationModernMutationVariables = {
    input: DeleteFileInput;
};
export type deleteFileMutationModernMutationResponse = {
    readonly deleteFile: {
        readonly deletedFileIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type deleteFileMutationModernMutation = {
    readonly response: deleteFileMutationModernMutationResponse;
    readonly variables: deleteFileMutationModernMutationVariables;
};



/*
mutation deleteFileMutationModernMutation(
  $input: DeleteFileInput!
) {
  deleteFile(input: $input) {
    deletedFileIds
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteFileInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteFilePayload",
    "kind": "LinkedField",
    "name": "deleteFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedFileIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteFileMutationModernMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation deleteFileMutationModernMutation(\n  $input: DeleteFileInput!\n) {\n  deleteFile(input: $input) {\n    deletedFileIds\n  }\n}\n"
  }
};
})();
(node as any).hash = '8bb2b188b9c68923c33c3affbb914700';
export default node;
